var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 320,
    viewBox: "0 0 540 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5935_1465)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37259 5.37258 0 12 0H528C534.627 0 540 5.37258 540 12V320H0V12Z",
    fill: "#004A70"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter0_f_5935_1465)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M502.307 159.549C502.307 233.858 398.144 294.097 269.653 294.097C141.162 294.097 37 233.858 37 159.549C37 85.2395 141.162 25 269.653 25C398.144 25 502.307 85.2395 502.307 159.549Z",
    fill: "#00A4FA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5935_1465",
    x: -163,
    y: -175,
    width: 865.307,
    height: 669.097,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_5935_1465"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5935_1465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 320,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupBg);
export default __webpack_public_path__ + "static/media/popup-bg.d434ca7559bc20f4836999c44ec7e4c6.svg";
export { ForwardRef as ReactComponent };